
var finansudd = finansudd || {};

finansudd.print = new function(){

    var self = this;

    this.printModule = function (selector) {

   		var data = $(selector).clone().children();

   		$(data).find('script').remove();
   		var dataContainer = $('<div></div>').html(data)
   		var title = $("title").html();
   		var printWindow = window.open('/print.htm', '.print', 'height=800,width=640');
   		printWindow.document.write('<html><head><title>' + title + '</title>');
   		printWindow.document.write('<link href="/dist/css/popup.min.css" rel="stylesheet" type="text/css" />');
   		printWindow.document.write('</head><body>');
   		printWindow.document.write($(dataContainer).html());
   		printWindow.document.write('</body></html>');
   		printWindow.document.close();
   		printWindow.focus();
   		printWindow.onload = function () {
   		    printWindow.print();
   		}
   		//printWindow.print();
   		//printWindow.close();
   		return true;

    };

};